import React from 'react'
import { useState, useEffect } from 'react'
import constant from '../../../constant'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import queryString from 'query-string'
import { editGovtJob, editGovtResult } from '../../../actions/utilitiesAction'
import EditGovtJob from '../../../component/Utilities/GovernmentJobs/EditGovtJob'
import EditGovtResults from '../../../component/Utilities/GovernmentResult/EditGovtResult'


const EditGovtResult = () => {

    const [response, setResponse] = React.useState({})
    const [showMsg, setShowMsg] = React.useState(false)
    const [list, setList] = useState([])
    const navigate = useNavigate()
    useEffect(() => {
        document.title = constant.title.editgovtresult
    })
    const onSubmit = (model) => {
        editGovtResult(model).then((res) => {
            setResponse(res)
            setShowMsg(true)
            
            setTimeout(() => {
                setShowMsg(false)
            }, 2000)
            navigate(constant.component.govtjobsresult.url)
                }).catch((err) => {
            alert(err)
        })
    }


    return (
        <React.Fragment>
            <EditGovtResults
             onSubmit={(model)=>onSubmit(model)}
             response={response}
             showMsg={showMsg}
             list={list}
            />
        </React.Fragment>
    )
}

export default EditGovtResult
